import React, { Component } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import "react-table/react-table.css";
import "./qrlist.css"
import { configuration } from "../../appConfig";
import Axios from "axios";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class ScanList extends Component {
  state = { orders: [], color: "", startScan: false, count: 0 };
  componentDidMount() {
    this.getScanList();
    this.startTimer();
    this.checkServerscanStatus();

  }
  updateServer = () => {
    const partnerId = localStorage.getItem("partnerId");
    Axios.post(
      "http://driveandscan.de/scancommand/index.php?pid=" +
        partnerId +
        "&startScan=1",
      {}
    )
      .then((res) => {
        this.setState({ startScan: true, count: 0 });
        alert("Scan Initiated");
      })
      .catch((err) => {
      });
  };
  createLocalFile = () => {
    const url = "http://localhost:9001/api/v1/startScan";
    const payload = { color: this.state.color };
    Axios.post(url, payload)
      .then((res) => {
        this.updateServer();
      })
      .catch((err) => {
        alert("Error! Local Server Not Started..");
      });
  };
  checkServerscanStatus = () => {
    setInterval(() => {
      if (this.state.startScan) {
        const partnerId = localStorage.getItem("partnerId");
        Axios.post(
          "http://driveandscan.de/scancommand/index.php?pid=" +
            partnerId +
            "&getStatus=1",
          {}
        ).then((res) => {
          if (res.data.status === "0") {
            this.setState({ startScan: false });
          }
        });
      }
    }, 100000);
  };
  startTimer = () => {
    let count = this.state.count;

    setInterval(() => {
      if (this.state.startScan) {
        count = count + 1;
      }
      this.setState({ count });
    }, 100000);
  };

  getScanList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    if (partnerId) {
      
      
      const url = configuration.getScanList;
      

      const response = await Axios.get(url + "?partnerId=" + partnerId).then(
        (responseData) => {
          if (responseData.data.data && responseData.data.data && responseData.data.data.length > 0) {

            const dd = responseData.data.data.filter(t=>{
              return !t.vin.includes('_')

            });
            this.setState({ orders: dd });
          }
          else{
          }
        }
      );
      
      /* if (response && response.data && response.data.length > 0) {

      const dd = response.data.filter(t=>{
      return !t.vin.includes('_')


        })

        this.setState({ orders: dd });
      } */
    } else {

      this.props.history.push("/login");
    }
  };

  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );

  render() {
    const partnerId = localStorage.getItem("partnerId");
    const columns = [
      {
        Header: "Sr. No",
        id: "row",
        maxWidth: 60,
        className:"tr-srno",
        filterable: false,
        Cell: (row) => {
          return <div>{row.index + 1}</div>;
        },
      },
      {
        Header: "VIN Number",
        filterable: true,
        width:200,
        className:"tr-vinnumber",
        maxWidth: 300,
        accessor: "vin",

        Cell: (props) => (
          <span
            style={{ textAlign: "center"}}
            // onClick={() => {
            //   localStorage.setItem("selectedFile", props.row.vin);
            //   localStorage.setItem("userSession", "");
            //   this.props.history.push({
            //     pathname: "/CreateVin",
            //     search: "?vin=" + props.row.vin,
            //     state: { detail: props.row },
            //   });
            // }}
          >
            {props.value}
          </span>
        ),
      },
      {
        id: "Estimate Id", // Required because our accessor is not a string
        Header: "Estimate Id",
        maxWidth: 200,
        className:"tr-estimateid",
        accessor: "orderid",
        filterable: true,
      },
      {
        Header: "Reg Number",
        filterable: true,
        maxWidth: 200,
        accessor: "regNo",
        Cell: (props) => (
          <span
            style={{ textAlign: "center",}}
            onClick={() => {
              localStorage.setItem("selectedFile", props.row.vin);
            }}
          >
            {props.value}
          </span>
        ),
      },

      {
        id: "Make", // Required because our accessor is not a string
        Header: "Make",
        maxWidth: 180,
        accessor: "manufacturer",
      },
      {
        id: "Model", // Required because our accessor is not a string
        Header: "Model",
        maxWidth: 180,
        accessor: "model",
      },
      {
        id: "Color", // Required because our accessor is not a string
        Header: "Color",
        maxWidth: 180,
        accessor: "color",
      },

      {
        id: "InsurenceName", // Required because our accessor is not a string
        Header: "Insuarence Client",
        maxWidth: 200,
        accessor: "InsurenceName",
      },
      
      {
        Header: (props) => <span>Images</span>, // Custom header components!
        minWidth: 100,
        Cell: (props) => (
          <span style={{}}>
            <Link
              className="btn btn-outline-info text-decoration-none"
              style={{ fontSize: 17 }}
              to="/ImageEditor"
              onClick={() => {
                localStorage.setItem("selectedFile", props.row.vin);
              }}
            >
              <i className="fa fa-picture-o" aria-hidden="true"></i> Take Pictures
            </Link>
          </span>
        ),
      },
    ];
    const tableProps = {
      defaultPageSize: 5,
      filterable: false,
      defaultSortDesc: false,
      showPagination: true,
      showPageSizeOptions: false,
    };
    function filterCaseInsensitive(filter, row) {
      const id = filter.pivotId || filter.id;
      return row[id] !== undefined
        ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
        : true;
    }
    return (
      <div className="animated fadeIn qr-list-table">
        
                <Row>
                  <Col>
                    <div className="card m-0">
                        <CardHeader>
                          <div className="row p-0">
                              <Col lg-6>
                                <h4>Scan LIST</h4>
                              </Col>
                              <Col lg-6>
                                <Link to="CreateVin"> 
                                  <button type="button " className="btn btn-lg pull-right new-qr-btn">
                                  <i className="mdi mdi-qrcode"></i> Create VIN
                                  </button>
                                </Link>
                              </Col>
                          </div>
                        </CardHeader>
                    </div>
                  </Col>
              </Row>
              <Row>
                <Col>
                  <Card>
                    <div className="CardBody p-0">
                      <ReactTable
                        id="t12"
                        style={{ textAlign: "center" }}
                        data={this.state.orders}
                        columns={columns}
                        {...tableProps}
                        minRows={0}
                        defaultPageSize={15}
                        defaultFilterMethod={(filter, row) =>
                          filterCaseInsensitive(filter, row)
                        }
                      />
                    </div>
                  </Card>
                </Col>
              </Row>
      </div>
    );
  }
}

export default ScanList;
